module.exports = __webpack_public_path__ + "assets/img/official-media-modal-layer-1-4323735f.png";